export default __webpack_public_path__ + "static/media/step-3.b354d182.gif";